<template>
  <div class="app-main-layout">
    <Navbar />

    <div class="content-with-sidebar-layout">
      <router-view />

      <BotSidebar />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/app/general/Navbar";
import BotSidebar from "@/components/app/general/BotSidebar";

export default {
  name: "bot-layout",
  components: {
    Navbar,
    BotSidebar,
  },
};
</script>

<style lang="scss">
.content-with-sidebar-layout {
  width: 100%;
  height: calc(100vh - 60px);

  display: flex;
  flex-direction: row;
  justify-content: stretch;

  position: relative;
  z-index: 50;
}
.app-main-layout {
  background-color: #3b3b3b;
  height: 100vh;
}
</style>
